/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import HowItWorksSectionBase from "../../../Common/HowItWorksSection/HowItWorksSectionBase";
import PenIcon from "../../../../../assets/icons/traffic/toggleable/IconWriting";
import IncomingCallIcon from "../../../../../assets/icons/traffic/toggleable/IconIncomingCall";
import HandshakeIcon from "../../../../../assets/icons/traffic/toggleable/IconShakeHands";

const HowItWorksSectionAlimony = () => {
  return (
    <HowItWorksSectionBase
      sections={[
        {
          title: "1. Unterhalt berechnen",
          description: "Sie erstellen sich in nur 5 Minuten Ihr persönliches Dokument zum Thema Unterhalt.",
          icon: PenIcon,
        },
        {
          title: "2. Termin für Erstberatung",
          description: "Wir prüfen Ihren Fall und rufen Sie zur von Ihnen gewünschten Uhrzeit an.",
          icon: IncomingCallIcon,
        },
        {
          title: "3. Weitere Schritte einleiten",
          description: "Wir besprechen Ihre Möglichkeiten und Sie entscheiden sich, wie Sie weiter vorgehen möchten.",
          icon: HandshakeIcon,
        },
      ]}
    />
  );
};

export default HowItWorksSectionAlimony;
